import { PropTypes } from "prop-types";
import { StyledDecisionLink } from "../../../styles/StyledDecisionLink";
import activeLinkIcon from "../../../assets/img/icons/link-active.svg";
import inactiveLinkIcon from "../../../assets/img/icons/link-inactive.svg";
import SaveIcon from "../../../assets/img/icons/save.svg";
import deleteIcon from "../../../assets/img/icons/close.svg";
import Modal from "react-modal";
import { useState } from "react";
import { ConfirmationModal } from "../../ConfirmationModal";
import { addDecisionUrl, deleteDecisionUrl } from "../../../api/decision/decision";
import ModalHeader from "../../ModalHeader/ModalHeader";
import { Button } from "../../Button";
import { StyledModalTextarea } from "../../../styles/StyledModalTextarea";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { StyledModal } from "../../../styles/StyledModal";

export default function DecisionLink({ id, editable = false, url, refetch }) {
	const { axiosPrivate } = useAxiosPrivate();

	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
	const [text, setText] = useState("");

	const handleDelete = async () => {
		await deleteDecisionUrl(axiosPrivate, refetch, id);
	};

	const handleUpdate = async () => {
		await addDecisionUrl(axiosPrivate, id, text, () => {
			setModalIsOpen(false);
			refetch();
		});
	};

	if (!editable && !url) {
		return <span></span>;
	}

	return (
		<>
			<StyledDecisionLink>
				<a
					href={url ? url : ""}
					target="_blank"
					rel="noreferrer"
					className={url || !editable ? "inactive" : "active"}
					onClick={(e) => {
						if (!url) {
							e.preventDefault();
							setModalIsOpen(true);
						}
					}}
				>
					<img src={url || !editable ? inactiveLinkIcon : activeLinkIcon} />
					<span>{url || !editable ? "Document link" : "Add document link"}</span>
				</a>
				{url && editable && <img src={deleteIcon} onClick={() => setIsConfirmModalOpen(true)} />}
			</StyledDecisionLink>
			<Modal
				isOpen={isConfirmModalOpen}
				onRequestClose={() => setIsConfirmModalOpen(false)}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal handleDelete={handleDelete} closeModal={() => setIsConfirmModalOpen(false)} />
			</Modal>
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => setModalIsOpen(false)}
				style={StyledModal}
				appElement={document.getElementById("app")}
				role="urlEdit-modal"
			>
				<ModalHeader onClick={() => setModalIsOpen(false)} data-testid="urlEdit-modalHeader">
					Add document link
				</ModalHeader>
				<StyledModalTextarea size="small">
					<input
						role="urlEdit-textarea"
						data-testid="urlEdit-textarea"
						onChange={(e) => {
							setText(e.target.value);
						}}
						defaultValue={text}
						type="text"
					/>
					<div>
						<Button testid="urlEdit-cancelButton" onClick={() => setModalIsOpen(false)} bg={false} small={true}>
							Cancel
						</Button>
						<Button
							icon={SaveIcon}
							testid="urlEdit-submitButton"
							onClick={() => {
								handleUpdate();
							}}
						>
							Save changes
						</Button>
					</div>
				</StyledModalTextarea>
			</Modal>
		</>
	);
}

DecisionLink.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	editable: PropTypes.bool,
	url: PropTypes.string,
	refetch: PropTypes.func,
};
